import React from 'react';
import { Grid, Box, Typography, Paper } from '@mui/material';
import { MileageStats as MileageStatsType } from '../../../services/dashboardService';
import { useTranslation } from 'react-i18next';
import SpeedIcon from '@mui/icons-material/Speed';
import CalculateIcon from '@mui/icons-material/Calculate';
import EventNoteIcon from '@mui/icons-material/EventNote';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

interface MileageStatsProps {
  data: MileageStatsType;
}

/**
 * Composant pour afficher les statistiques kilométriques
 */
const MileageStats: React.FC<MileageStatsProps> = ({ data }) => {
  const { t } = useTranslation();

  const stats = [
    {
      label: t('dashboard:mileageStats.totalKilometers'),
      value: data.totalKilometers.toLocaleString(),
      icon: <SpeedIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
      suffix: 'km',
    },
    {
      label: t('dashboard:mileageStats.averagePerVehicle'),
      value: data.averagePerVehicle.toLocaleString(),
      icon: <CalculateIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
      suffix: 'km',
    },
    {
      label: t('dashboard:mileageStats.monthlyReports'),
      value: data.monthlyReports,
      icon: <EventNoteIcon sx={{ fontSize: 30, color: '#1976d2' }} />,
    },
    {
      label: t('dashboard:mileageStats.comparedToLastMonth'),
      value: `+${data.monthlyChange}%`,
      icon: data.monthlyChange >= 0 ? (
        <TrendingUpIcon sx={{ fontSize: 30, color: '#4caf50' }} />
      ) : (
        <TrendingDownIcon sx={{ fontSize: 30, color: '#f44336' }} />
      ),
      color: data.monthlyChange >= 0 ? '#4caf50' : '#f44336',
    },
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat, index) => (
        <Grid item xs={6} key={index}>
          <Paper
            sx={{
              p: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 2,
            }}
            elevation={1}
          >
            <Box sx={{ mb: 1 }}>{stat.icon}</Box>
            <Typography 
              variant="h6" 
              component="div" 
              align="center"
              sx={{ color: stat.color }}
            >
              {stat.value}{stat.suffix ? ` ${stat.suffix}` : ''}
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              {stat.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default MileageStats;